import type * as React from "react";

import type { IBenchmarkOvertimeProps } from "pro-features/pages/segments/components/benchmarkOvertime/types";

import { BenchmarkOvertime } from "./benchmarkOvertime";

export const SegmentsVsGroupOvertime: React.FC<IBenchmarkOvertimeProps> = (props) => {
    return <BenchmarkOvertime {...props} />;
};
